import { Component, Injector, OnInit, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { COMMON_MODULES } from '@src/app/core/constants/common-module.constant';
import { BannerOneModule } from '@src/app/core/shared/components/ui/banner/banner-one/banner-one.module';
import { HeadingBlockOneModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-one/heading-block-one.module';
import { HeadingBlockFullWidthModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-fullwidth/heading-block-fullwidth.module';
import { IconboxOneModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-one/iconbox-one.module';
import { IconboxTwoModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-two/iconbox-two.module';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { ImageboxFullwidthModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-fullwidth/imagebox-fullwidth.module';
import { CardboxOneModule } from '@src/app/core/shared/components/ui/cardbox/cardbox-one/cardbox-one.module';
import { IMAGES_URL } from '@src/app/core/constants/system-list.constant';
import { HelperService, SharedDataService } from '@src/app/core/services';
import { ALL_SERVICES, COMPARE_MEDS_SEARCH, PLUS_MEMBERSHIP, ROUTES } from '@src/app/core/constants';
import { CoreClass } from '@src/app/core/base/core.class';
import { environment } from '@src/environments/environment';
import { MiniEnvInfoCardComponent } from '@src/app/core/shared/components/ui/cardbox/mini-env-info-card/mini-env-info-card.component';
import { ImageboxBulletScrollComponent } from '@src/app/core/shared/components/ui/imagebox/imagebox-bullet-scroll/imagebox-bullet-scroll.component';
import { MiniEnvHeadingBlockComponent } from '@src/app/core/shared/components/ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';
import { MiniEnvFaqsComponent } from '@src/app/core/shared/components/mini-env/mini-env-faqs/mini-env-faqs.component';
import { MiniEnvBannerComponent } from "@src/app/core/shared/components/ui/banner/mini-env-banner/mini-env-banner.component";
import { MiniEnvFooterComponent } from '../../layout/mini-env/footer/footer.component';
import { MiniEnvSubFooterComponent } from '@src/app/core/shared/components/mini-env/mini-env-sub-footer/mini-env-sub-footer.component';
import { MembershipPlanComponent } from '@src/app/core/shared/components/membership-plan/membership-plan.component';
import { MembershipPlanModule } from '@src/app/core/shared/components/membership-plan/membership-plan.module';
import * as faqsJson from '@src/assets/i18n/mini-env/acawellness/en.json';
import { VideoPlayerComponent } from '@src/app/core/shared/components/video-player/video-player.component';
import * as config from '@src/assets/tenant-assets/mini-env/mini-env-config.json';
import { MiniEnvContentBoxComponent } from '@src/app/core/shared/components/mini-env/mini-env-content-box/mini-env-content-box.component';
import { SearchInputComponent } from '@src/app/core/shared/components/search-input/search-input.component';
import { info } from 'console';

declare var $: any;
@Component({
  selector: 'app-amac',

  templateUrl: './amac.component.html',
  styleUrl: './amac.component.scss',
  preserveWhitespaces: true,
  standalone: true,
  imports: [
    ...COMMON_MODULES,
    HeadingBlockOneModule,
    IconboxOneModule,
    IconboxTwoModule,
    HeadingBlockFullWidthModule,
    ImageboxOneModule,
    ImageboxFullwidthModule,
    CardboxOneModule,
    BannerOneModule,
    MiniEnvContentBoxComponent,
    MiniEnvInfoCardComponent,
    ImageboxBulletScrollComponent,
    MiniEnvHeadingBlockComponent,
    MiniEnvFaqsComponent,
    MiniEnvBannerComponent,
    MembershipPlanModule,
    VideoPlayerComponent,
    SearchInputComponent
  ]
})
export class AMACComponent extends CoreClass implements OnInit {
  testimonials: any = [];
  blogs: any = [];
  IMAGES_URL: string = IMAGES_URL;
  faqList = faqsJson.FAQS.FAQ_LIST;
  imgSrc = 'assets/tenant-assets/mini-env/images/package-delivery.png';
  isLoading = false
  noData = false
  steps = [
    {
      id: '1',
      title: '01. Log In to Your Account',
      description: 'Log in and visit your pharmacy dashboard.'
    },
    {
      id: '2',
      title: '02. Explore Your Pharmacy Benefits',
      description: 'Browse available medications to view pricing, delivery, & pick-up options'
    },
    {
      id: '3',
      title: '03. Get Started With Medications Simplified',
      description: 'Inform your doctor to send prescriptions to your preferred pharmacy.'
    },
  ]

  constructor(
    injector: Injector,
    private httpClient: HttpClient,
    private helperService: HelperService
  ) {
    super(injector);
  }
  All_SERVICES_PATH: string = ALL_SERVICES;
  membershipCode = ''
  services = [
    {
      id: '01',
      title: 'Urgent Care',
      description: '24/7 available virtual urgent care for non-life-threatening situations.',
      icon: 'siren 1.png',
      isFree: true,
      link: ROUTES.virtualUrgentCare
    },
    {
      id: '02',
      title: 'Mental Health Counseling',
      description: 'Mental health support with certified mental health specialists.',
      icon: 'mental-health 1.png',
      isFree: true,
      link: ROUTES.mentalHealth
    },
    {
      id: '03',
      title: 'Medications',
      description: 'Free generics, with discounts on brand-name prescriptions.',
      icon: 'medicine (2) 1.png',
      isFree: true,
      link: ROUTES.pharmacy
    },
    {
      id: '08',
      title: 'Imaging',
      description: 'Clear, transparent, and discounted rates at 4,000+ labs nationwide.',
      icon: 'mri-machine 1.png',
      isFree: false,
      link: ROUTES.imaging
    },
    {
      id: '04',
      title: 'Office Visits',
      description: 'Save up to 35% with 350k+ doctors nationwide.',
      icon: 'hospital (1) 1.png',
      isFree: false,
      link: ROUTES.officeVisit
    },


    {
      id: '07',
      title: 'Lab Tests',
      description: 'Save up to 60% at 2,100+ lab locations.',
      icon: 'test-tube 1.png',
      isFree: false,
      link: ROUTES.labTest
    },



    {
      id: '09',
      title: 'Procedures',
      description: 'Save 50%+ on procedures at 5,000+ surgery centers.',
      icon: 'robotic-surgery 1.png',
      isFree: false,
      link: ROUTES.surgical
    }];

  faqs: any[] = [
    {
      question: 'What is the difference between WoW Plus & health insurance?',
      answer: 'WoW Plus provides steeply discounted access to medical providers... It is not insurance but a direct pay network...'
    },
    {
      question: 'Why do I need WoW Health?',
      answer: 'It provides affordable access to routine care and prescriptions...'
    }
  ];

  bannerSlides: any[] = [
    {
      title: 'Affordable Medications, Always within your Reach',
      subtitle: 'Save More. Stress Less. Get free and discounted medications with zero hassle. Whether it’s chronic care or one-time prescriptions, we make pharmacy simple, transparent, and cost-effective.',
      discription: '',
      buttonText: 'Login',
      buttonAction: "login",
      buttonText2: 'Sign Me Up',
      buttonAction1: "register",
      bannerClass: 'script-saver-amac',
      info: 'First Time User?',
      buttonAction2: 'creat',
      buttonText3: 'Create Password',
      link: '/join',

    }
  ];

  ngOnInit(): void {
    this.sharedService.removeNavbarLinks = false;
    this.helperService.changeMiniEnvColor()

    // Default the search zip code field to the logged-in user's zip code;
    // fall back to the default zip for guests or users without one on file.
    this.sharedService.pharmacyInfo.zipCode =
      this.storageService.getUserInformation()?.zipCode || "48243";
  }
  getTestimonials() {
    // this code need improvement
    const apiUrl = `/assets/tenant-assets/testimonials/en.json`;
    this.httpClient.get(apiUrl).subscribe((data: any) => {
      this.testimonials = data; // Assign the data to the property
    });
  }
  getBlogs() {
    // this code need improvement
    const apiUrl = `/assets/tenant-assets/blogs/en.json`;
    this.httpClient.get(apiUrl).subscribe((data: any) => {
      this.blogs = data; // Assign the data to the property
    });
  }
  getMedicines(drugName = '') {
    this.isLoading = true;
    let endpoint = COMPARE_MEDS_SEARCH + drugName;

    if (drugName == '') {
      this.isLoading = false
      this.sharedService.results = [];
      return;
    }

    this.httpService.requestEntity('GET', endpoint)
      // .pipe(takeUntil(this.onDestroy$))
      .subscribe((res: any) => {

        let response = res.body;
        this.sharedService.results = response.data;
        this.isLoading = false
        response.data.length === 0 ? this.noData = true : this.noData = false
      },
        (error: any) => {
          this.isLoading = false
        }
      )
  }
  buttonAction(event: any) {
    if (event === 'login') {
      this.router.navigateByUrl(ROUTES.login);
    }
    else if (event === 'register') {
      window.open("https://www.getcadrplus.com/order/checkout.cfm?id=861766&pdid=43663", '_blank');
    }
    else if (event === 'creat') {
      this.router.navigateByUrl(ROUTES.createPassword);
    }
  }

  buttonAction2(event: any) {
    if (event === 'creat') {
      this.router.navigateByUrl(ROUTES.login);
    }
  }

  getStartedAction() {
    this.router.navigateByUrl(PLUS_MEMBERSHIP);
  }
  login() {
    this.router.navigateByUrl(ROUTES.login);
  }

}

